<template>
    <figure class="hero" :style="styleObject">
        <img class="hero__image" :src="image" alt="">
        <figcaption v-if="claim" class="hero__content frame-large">
            <h2 class="hero__claim">{{ claim }}</h2>
        </figcaption>
    </figure>
</template>

<script>

export default {
    name: 'Hero',
    props: {
        image: String,
        claim: String,
        styleObject: Object
    }
}
</script>

<style lang="scss">

@import '../scss/config';

$c-hero-use-color-overlay: false !default;

%hero-faint-background {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    outline: 1px solid red;
    background: color(accent);
    position: absolute;
    top: 0;
    opacity: .5;
}

.hero {
    display: block;
    position: relative;
    margin: 0;
    height: rem(152);

    &::before {
        @extend %hero-faint-background;
        background: color(middleground);
    }

    @if $c-hero-use-color-overlay {
        &::after {
            @extend %hero-faint-background;
        }
    }

    &__image {
        width: 100%;
        height: auto;
        margin: 0;
        display: block;
        position: relative;

        @if $c-hero-use-color-overlay {
            filter: grayscale(1);
        }
    }

    &__content {
        @include center-children-vertically;

        margin: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    &__claim {
        @include font-semibold();
        font-size: size(font-medium);
    }
}
</style>
